import React from "react";
import checkStatus from "../../../assets/check-status.svg";

const InactiveEntityPlus = () => {
  return (
    <div className="formgrid grid flex justify-content-center align-item-center">
      <div className="inactive-entity-plus">
        <img src={checkStatus} alt="Check Status" />

        <div className="info-container">
          <p className="title">No additional information needed</p>
          <p className="description">
            You're all set for now! If we need anything else, we'll let you
            know.You can move on to the next step.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InactiveEntityPlus;
